import { IFilterParam } from './IFilterParam';
import { ITableParams } from './ITableParams';

export class GridUtil {
    static setRowCliclk(gridName: string, selectedRowsIndex, selectedDataRowsId): any {
        let tableParams = GridUtil.getTableParams(gridName);
        sessionStorage.setItem(gridName, JSON.stringify(selectedRowsIndex));
        sessionStorage.setItem(`${gridName}_tableParams`, JSON.stringify(tableParams));
        sessionStorage.setItem(`${gridName}_SelectedDataID`, JSON.stringify(selectedDataRowsId));
    }
    static getSelectedDataID(gridName: string): number[] {
        let selectedDataID = JSON.parse(sessionStorage.getItem(`${gridName}_SelectedDataID`)) as number[];
        if (selectedDataID === null || selectedDataID === undefined || selectedDataID.length === 0) {
            selectedDataID = [];
        }
        return selectedDataID;

    }
    static setTableParams(gridName: string, tableParams: ITableParams): void {
        sessionStorage.setItem(`${gridName}_tableParams`, JSON.stringify(tableParams));
    }
    static setTableSearchParams(gridName: string, tableParams: IFilterParam[], isAdvanceSearch: boolean = false): void {
        var data  = {tableParams,isAdvanceSearch}
        sessionStorage.setItem(`${gridName}_tableSearchParams`, JSON.stringify(data));
    }
    static getTableSearchParams(gridName: string) {
        let tableParams = JSON.parse(sessionStorage.getItem(`${gridName}_tableSearchParams`));
        if (tableParams === null || tableParams === undefined) {
            tableParams = {} as IFilterParam[];
        }
        return tableParams;
    }
    static getSelectedIndex(gridName: string): number[] {
        let selectedIndex = JSON.parse(sessionStorage.getItem(gridName)) as number[];
        if (selectedIndex === null || selectedIndex === undefined || selectedIndex.length === 0) {
            selectedIndex = [];
        }
        return selectedIndex;

    }
    static getTableParams(gridName: string): ITableParams {
        let tableParams = JSON.parse(sessionStorage.getItem(`${gridName}_tableParams`)) as ITableParams;
        if (tableParams === null || tableParams === undefined) {
            tableParams = {} as ITableParams;
        }
        return tableParams;
    }
    static clearSessionStorage(gridName: string): void {
        sessionStorage.removeItem(gridName);
        sessionStorage.removeItem(`${gridName}_tableParams`);
        sessionStorage.removeItem(`${gridName}_tableSearchParams`);
        sessionStorage.removeItem(`${gridName}_SelectedDataID`);
        sessionStorage.removeItem("clearGridSelection");
    }
    static getGridSelection() {
        return sessionStorage.getItem("clearGridSelection");
    }
    static setClearGridSelection() {
        sessionStorage.setItem("clearGridSelection", "true");
    }
    static movedToLastPage(gridName: string, value = "true"): void {
        sessionStorage.setItem(`${gridName}_movedToLastPage`, value);
    }
    static isMovedToLastPage(gridName: string): boolean {
        let lastPageMoved = sessionStorage.getItem(`${gridName}_movedToLastPage`);
        if (lastPageMoved === null || lastPageMoved === undefined) {
            lastPageMoved = "false";
        }
        return lastPageMoved === "true";
    }
}
